import { render } from "./UploadPage.vue?vue&type=template&id=6ab3b006"
import script from "./UploadPage.vue?vue&type=script&lang=js"
export * from "./UploadPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__